import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import React, { useState } from "react";
import Button from "../../form/button";
import ErrorMessage from "../../form/errorMessage";
import { IBlog, Status } from "../../../lib/types";
import { Input } from "../../ui/input";
import pb from "../../../lib/pocketbase";
import { useNavigate } from "react-router-dom";

export default function NewPost() {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");
    const [status, setStatus] = useState<Status>("none");

    function add() {
        if (!pb.authStore.model) return;
        setStatus("loading");
        const data: IBlog = {
            title: title,
            content: "",
            author: pb.authStore.model.id,
            banner: "",
            status: "Draft",
            published: new Date().toISOString()
        };

        pb.collection("blog")
            .create(data)
            .then((x) => {
                setTimeout(() => {
                    setStatus("success");
                    setError("");
                    setOpen(false);
                    navigate(`/studio/blog/${x.id}/edit`);
                }, 500);
            })
            .catch((err: Error) => {
                setStatus("error");
                setError(err.message);
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus("none");
                }, 3000);
            });
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button variant={"outline"}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                    New post
                </Button>
            </DialogTrigger>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>New post</DialogTitle>
                </DialogHeader>
                <ErrorMessage error={error} close={() => setError("")} />
                <Input value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Post title" />
                <DialogFooter className="gap-2">
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button status={status} onClick={() => add()} variant="dark">
                        {status === "loading" && "Adding"}
                        {status === "success" && "Added"}
                        {status === "error" && "Error"}
                        {status === "none" && "Add"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
